import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CalendarDays, ArrowRight } from "lucide-react";
import EventCard from "@/components/EventCard";

/** Relie l'actu aux ÉVÉNEMENTS locaux de la même ville (repli départemental).
 *  Jusqu'à 3 événements à venir, rendus en cartes compactes. */
export default function RelatedLocalEvents({ city = "", testId = "related-local-events" }) {
  const [events, setEvents] = useState(null);

  useEffect(() => {
    let alive = true;
    const _city = (city || "").trim();
    const url = _city && _city.toLowerCase() !== "eure-et-loir"
      ? `/public/events?city=${encodeURIComponent(_city)}&limit=6`
      : `/public/events?limit=6`;
    api.get(url)
      .then((r) => {
        if (!alive) return;
        const list = Array.isArray(r.data) ? r.data : [];
        // Dédoublonne par titre + date de début (une même sortie peut venir de 2 sources)
        const seen = new Set();
        const uniq = [];
        for (const e of list) {
          const k = `${(e.title || "").trim().toLowerCase()}|${(e.start_date || "").slice(0, 10)}`;
          if (seen.has(k)) continue;
          seen.add(k);
          uniq.push(e);
        }
        setEvents(uniq.slice(0, 3));
      })
      .catch(() => { if (alive) setEvents([]); });
    return () => { alive = false; };
  }, [city]);

  if (!events || events.length === 0) return null;
  const inCity = (city || "").trim() && (city || "").trim().toLowerCase() !== "eure-et-loir";

  return (
    <div className="mt-10 pt-6 border-t border-slate-100" data-testid={testId}>
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <h2 className="font-heading text-xl font-bold text-[#172A3A] inline-flex items-center gap-2">
          <CalendarDays size={20} className="text-[#E05638]" /> {inCity ? `Que faire à ${city.trim()}` : "Que faire près de chez vous"}
        </h2>
        <Link to="/sortir" className="inline-flex items-center gap-1 text-sm font-semibold text-[#E05638] hover:underline" data-testid={`${testId}-all`}>
          Tout l'agenda <ArrowRight size={14} />
        </Link>
      </div>
      <div className="mt-4 grid sm:grid-cols-3 gap-4">
        {events.map((e) => (
          <EventCard key={e.id} event={e} compact recurrenceLabel={e.is_recurring ? "Récurrent" : undefined} />
        ))}
      </div>
    </div>
  );
}
